import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Music2 } from "lucide-react";
import Logo from "./Logo";
import api from "../lib/api";
import { useI18n } from "../context/I18nContext";

const SOCIAL = [
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/global_afrique_international_", testid: "footer-social-instagram" },
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/share/1ByLJRFTcT/", testid: "footer-social-facebook" },
  { icon: Music2, label: "TikTok", href: "https://www.tiktok.com/@global_afrique", testid: "footer-social-tiktok" },
];

export default function Footer() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState(null);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await api.post("/subscribers", { email });
      setMsg(t("home.subscribed"));
      setEmail("");
    } catch {
      setMsg("—");
    }
  };

  return (
    <footer className="mt-20" style={{ backgroundColor: "var(--gai-white)", color: "var(--gai-black)", borderTop: "1px solid var(--gai-grey-200)" }}>
      <div className="h-1 w-full" style={{ background: "var(--gai-red)" }} aria-hidden />

      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 py-16 grid gap-14 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo size={64} />
          <p className="mt-6 max-w-md text-[0.95rem] leading-relaxed" style={{ color: "var(--gai-grey-700)" }}>
            {t("footer.tagline")}. {t("home.sub")}
          </p>

          <form onSubmit={subscribe} className="mt-6 flex items-center gap-3 max-w-md" data-testid="newsletter-form">
            <input
              type="email"
              required
              placeholder={t("auth.email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="gai-input flex-1"
              data-testid="newsletter-email"
            />
            <button className="gai-btn-gold" data-testid="newsletter-submit">{t("home.subscribe")}</button>
          </form>
          {msg && <p className="mt-3 text-[0.8rem]" style={{ color: "var(--gai-red)" }} data-testid="newsletter-feedback">{msg}</p>}

          <div className="mt-8 flex items-center gap-3" data-testid="footer-socials">
            <span className="text-[0.62rem] font-bold tracking-[0.24em] uppercase mr-2" style={{ color: "var(--gai-grey-500)" }}>
              Suivez-nous
            </span>
            {SOCIAL.map(({ icon: Icon, label, href, testid }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={testid}
                className="w-9 h-9 flex items-center justify-center transition-colors"
                style={{ border: "1px solid var(--gai-grey-300)", color: "var(--gai-black)" }}
                onMouseEnter={(e) => { e.currentTarget.style.background = "var(--gai-red)"; e.currentTarget.style.borderColor = "var(--gai-red)"; e.currentTarget.style.color = "var(--gai-white)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.borderColor = "var(--gai-grey-300)"; e.currentTarget.style.color = "var(--gai-black)"; }}
              >
                <Icon size={14} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <div className="text-[0.68rem] tracking-[0.24em] uppercase font-bold mb-4" style={{ color: "var(--gai-red)" }}>Navigation</div>
          <ul className="space-y-2.5 text-sm" style={{ color: "var(--gai-grey-800)" }}>
            <li><Link to="/magazine" className="hover:text-[var(--gai-red)]" data-testid="footer-magazine">{t("nav.magazine")}</Link></li>
            <li><Link to="/articles" className="hover:text-[var(--gai-red)]" data-testid="footer-articles">{t("nav.articles")}</Link></li>
            <li><Link to="/fondatrice" className="hover:text-[var(--gai-red)]" data-testid="footer-founder">{t("nav.founder")}</Link></li>
            <li><Link to="/annoncer" className="hover:text-[var(--gai-red)]" data-testid="footer-services">Annoncer dans GAI</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[0.68rem] tracking-[0.24em] uppercase font-bold mb-4" style={{ color: "var(--gai-red)" }}>{t("footer.contact")}</div>
          <ul className="space-y-2.5 text-sm" style={{ color: "var(--gai-grey-800)" }}>
            <li>contact@globalafriqueinternational.com</li>
            <li>devis@globalafriqueinternational.com</li>
            <li><Link to="/annoncer" className="hover:text-[var(--gai-red)]" data-testid="footer-quote">{t("nav.quote")}</Link></li>
            <li><Link to="/connexion" className="hover:text-[var(--gai-red)]" data-testid="footer-client">{t("nav.client")}</Link></li>
          </ul>
        </div>
      </div>

      <div style={{ borderTop: "1px solid var(--gai-grey-200)" }}>
        <div className="max-w-[1320px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-[0.68rem] tracking-[0.2em] uppercase" style={{ color: "var(--gai-grey-500)" }}>
          <div>© {new Date().getFullYear()} GLOBAL AFRIQUE INTERNATIONAL — {t("footer.rights")}</div>
          <div className="flex gap-6">
            <span>{t("footer.legal")}</span>
            <span>{t("footer.privacy")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
